/*
 * Module for the Benefit Payroll Adjustment Register criteria page
 */
rs.module("content/reports/criteria/benefitpayrolladjustmentregistercriteria",

    ["controls/data/grid", "common/select-helper"],

    function (gridModule, selectHelper) {

        function initialize(lrsGridApi, jsSelectors, ajaxUrls, compositeMonthYearColumnID) {
            var filter = $.js(jsSelectors.filter);
            var includeManualCheckBox = filter.js(jsSelectors.includeManualCheckBox);
            var includeLumpSumsCheckBox = filter.js(jsSelectors.includeLumpSumsCheckBox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            includeManualCheckBox.change(filterCheckBoxChanged);
            includeLumpSumsCheckBox.change(filterCheckBoxChanged);

            // refresh the grid based on checkbox selection
            function filterCheckBoxChanged() {
                loadingSpinner.show();
                gridModule.update(
                    ajaxUrls.refreshGridUrl,

                    { includeManualPayroll: includeManualCheckBox.is(':checked'), includeLumpSums: includeLumpSumsCheckBox.is(':checked') },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }

            var payrollProcessingMonthYearHidden = $.js(jsSelectors.payrollProcessingMonthYearHidden);

            // Populate the hidden field with the Payroll Period of the selected row
            lrsGridApi.selectionChanged(function (values, rows) {
                if (values.length > 0) {
                    var compositeMonthYear = rows[0][compositeMonthYearColumnID];
                    payrollProcessingMonthYearHidden.val(compositeMonthYear);
                } else {
                    payrollProcessingMonthYearHidden.val('');
                }
            });

            var adjustmentCategorySelect = $.js(jsSelectors.adjustmentCategorySelect);
            var availablePayComponentsMultiSelect = $.js(jsSelectors.availablePayComponentsMultiSelect);
            var availablePayComponentsMultiSelectHelper = selectHelper.getHelper(availablePayComponentsMultiSelect);

            // Clear validation by adding a pay component (as some types do not have pay components) and selecting it.
            // If no type selected, disable the available adjustments (pay components).
            // Populate the pay component with the new selected type.
            adjustmentCategorySelect.change(function () {
                availablePayComponentsMultiSelectHelper
                    .appendOptions([{ text: '', value: '' }])
                    .setValue('')
                    .setDisabled(this.value == '')
                    .loadOptionsFrom(ajaxUrls.updateAvailableAdjustmentsUrl, { adjustmentCategory: this.value });

                availablePayComponentsMultiSelect.clearErrors();
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);